export const GET_SERVICE_CONFIGURATION = "GET_SERVICE_CONFIGURATION";